import request from '@/utils/request'


export function create(data) {
  return request({
    url: '/api/eqp',
    method: 'put',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/eqp',
    method: 'post',
    data
  })
}

export function deleteById(id) {
  return request({
    url: '/api/eqp/'+id,
    method: 'delete',
  })
}

export function pagedQuery(data) {
  return request({
    url: '/db/eqp/eqp-page-query',
    method: 'post',
    data
  })
}


export function geMrUrlUpdate(data) {
  return request({
    url: '/api/ge-mr-url/update',
    method: 'post',
    data
  })
}


export function philipsCtUrlUpdate(data) {
    return request({
        url: '/api/philips-ct-url/update',
        method: 'post',
        data
    })
}


export function philipsMrUrlUpdate(data) {
    return request({
        url: '/api/philips-mr-url/update',
        method: 'post',
        data
    })
}



export function geCtUrlUpdate(data) {
    return request({
        url: '/api/ge-ct-url/update',
        method: 'post',
        data
    })
}


export function siemensCtUrlUpdate(data) {
    return request({
        url: '/api/siemens-ct-url/update',
        method: 'post',
        data
    })
}



export function queryMrUrlByEqpId(data) {
  return request({
    url: '/api/ge-mr-url/query-by-eqp-id',
    method: 'get',
    params:data
  })
}



export function queryPhilipsMrUrlByEqpId(data) {
    return request({
        url: '/api/philips-mr-url/query-by-eqp-id',
        method: 'get',
        params:data
    })
}


export function queryPhilipsCtUrlByEqpId(data) {
    return request({
        url: '/api/philips-ct-url/query-by-eqp-id',
        method: 'get',
        params:data
    })
}

export function querySiemensCtUrlByEqpId(data) {
    return request({
        url: '/api/siemens-ct-url/query-by-eqp-id',
        method: 'get',
        params:data
    })
}



export function queryGeCtUrlByEqpId(data) {
    return request({
        url: '/api/ge-ct-url/query-by-eqp-id',
        method: 'get',
        params:data
    })
}

export function daqTypeUpdate(data) {
  return request({
    url: '/db/eqp/daq-type-update',
    method: 'post',
    data
  })
}

export function daqWarnEditQuery(data) {
  return request({
    url: '/api/eqp-log/daq-warn-edit-query',
    method: 'post',
    data
  })
}

export function daqWarnEdit(data) {
  return request({
    url: '/api/eqp-log-daq-warn-value/daq-warn-edit-update',
    method: 'post',
    data
  })
}

// 返显之前的配置信息
export function eqpNotifierQuery(data){
  return request({
    url:'/db/eqp/eqp-notifier-query',
    method:'post',
    data
  })
}

//通过phone获取外部系统用户信息
export function notifierQuery(data){
  return request({
    url:'/db/sensor/notifier-query',
    method:'post',
    data
  })
}

//修改通知人
export function notifyUpdate(data){
  return request({
    url:'/db/eqp/notify-update',
    method:'post',
    data
  })
}


export default { create,update,deleteById,pagedQuery,queryMrUrlByEqpId,queryGeCtUrlByEqpId,geCtUrlUpdate,geMrUrlUpdate,siemensCtUrlUpdate,daqTypeUpdate,daqWarnEditQuery,daqWarnEdit,notifierQuery,notifyUpdate,eqpNotifierQuery,querySiemensCtUrlByEqpId ,philipsCtUrlUpdate, philipsMrUrlUpdate, queryPhilipsMrUrlByEqpId, queryPhilipsCtUrlByEqpId}